import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { AdminPromotion } from '../../core/models/admin.models';

@Component({
  selector: 'app-promotion-form',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule],
  templateUrl: './promotion-form.component.html'
})
export class PromotionFormComponent implements OnInit {
  @Input() promotionData: AdminPromotion | null = null;
  @Output() save = new EventEmitter<Partial<AdminPromotion>>();
  @Output() cancel = new EventEmitter<void>();

  form!: FormGroup;

  constructor(private fb: FormBuilder) {}

  ngOnInit() {
    this.form = this.fb.group({
      code: [this.promotionData?.code || '', Validators.required],
      name: [this.promotionData?.name || '', Validators.required],
      type: [this.promotionData?.type || 'percent', Validators.required],
      value: [this.promotionData?.value || 0, [Validators.required, Validators.min(0)]],
      max_discount: [this.promotionData?.max_discount || null],
      starts_at: [this.promotionData?.starts_at || null],
      ends_at: [this.promotionData?.ends_at || null],
      usage_limit: [this.promotionData?.usage_limit || null],
      is_active: [this.promotionData?.is_active ?? true]
    });
  }

  submit() {
    if (this.form.valid) {
      this.save.emit(this.form.value);
    } else {
      this.form.markAllAsTouched();
    }
  }
}
